import * as u from './utils';
import { throttle } from 'throttle-debounce';

export default () => {
    if (document.querySelectorAll('.sticky-menu').length > 1) {
        return;
    }

    const handleScroll = () => {
        // Fix for hovering the menu when scrolled causing a scroll event due to noScroll
        if (u.hasClass(document.body, 'menu-open')) {
            return;
        }

        if (window.pageYOffset > 200) {
            u.addClass(document.body, 'has-scrolled');
        } else {
            u.removeClass(document.body, 'has-scrolled');
        }
    };

    handleScroll();
    window.addEventListener('scroll', throttle(50, handleScroll));
};
